<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DED" id="_idParaDest-2"><a id="page_v">For Sarah, Charlotte, Hugo, Natasha, and Poppy</a></p><a id="page_v">
</a></div><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?12a421c5